import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { FireAssessmentService } from 'src/app/services/fire-assessment.service';
import { ActivatedRoute, Router } from "@angular/router"; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common';  // Location service is used to go back to previous component
import * as firebase from 'firebase/app';
import { DataSnapshot } from '@angular/fire/database/interfaces';
import { CommonModule } from '@angular/common';
import * as html2pdf from 'html2pdf.js';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
import { ViewsComponent } from '../../views/views.component';
//Dre Imports for Chart
import { Chart, ChartDataSets, ChartOptions } from 'chart.js';
import { Color, BaseChartDirective, Label } from 'ng2-charts';
import { B2Bvalue, B2Cvalue, showQ15to17 } from 'src/app/components/assessment/add-assessment/add-assessment.component';
import { assessmentApiEndpoint } from 'src/app/consts/conts.global';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { FireCalcRevenueService } from 'src/app/services/calc-revenue-service/fire-calc-revenue.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';


interface ImplementationStatus {
  value: string;
  viewValue: string;
}



@Component({
  selector: 'app-calc-revenue',
  templateUrl: './calc-revenue.component.html',
  styleUrls: ['./calc-revenue.component.scss'],
})

export class CalcRevenueComponent implements OnInit {


  //implement Read More
  isReadMore = true;

  showTxt() {
    this.isReadMore = !this.isReadMore;
  }

  
  constructor(
    public fireAssessment: FireAssessmentService,
    private router: Router,
    private location: Location,
    private actRoute: ActivatedRoute,
    private guard: AuthGuard,
    private http: HttpClient,
    public fireCalcRevenue: FireCalcRevenueService,
    private _formBuilder: FormBuilder,

  ) { }



  //declare form variable here
  public calcRevenueFormGroup: FormGroup;
  public calcdata: any;
  public  dataCalcRev!: any;
  calcRevenueID: any
  calcRevID: any;
  offerListArray: FormArray;

  data!: any;

  //Demographics

  busiName: string;
  busiFirstName: string;
  busiLastName: string;
  busiZipcode: string;
  busiRegType: string;

  //Chart data
  revModel!: any;
  revInitialCapital!: number;
  revStartingCosts!: number;
  revPerUser!: number;
  revCOGS!: number;
  revFixedCostPerMonth!: number;
  revInitUsers!: number;
  revMonthlyUserGrowth!: number;
  revMonthlyUserLoss!: number;

  B2BValueCopy!: number;
  B2CValueCopy!: number;

  assessmentPayload: any;

  ngOnInit(): void {
    this.calcRevenueForm();  
  }

  retrieveRecommandationText(property: string): string {
    const recommendation = this.assessmentPayload?.userAssessmentRecommandations?.find((rec: any) => rec?.hasOwnProperty(property) && rec[property]);
    return (recommendation && recommendation[property]) || '';
  }

  tabNum = 0;
  nextTab() {
    if(this.tabNum < 5) {
      this.tabNum++;
    }
  }
  prevTab() {
    if(this.tabNum > 0) {
      this.tabNum--;
    }
  }

  
  onSubmit() {
    debugger
    const calcRevenueID = this.fireCalcRevenue.createCalcRevenue({...this.calcRevenueFormGroup.value})

  /*  const calcRevenueID = this.fireCalcRevenue.createCalcRevenue({
    this.calcRevenueFormGroup.revInitialCapital = this.revInitialCapitalSaved,
    this.revStartingCosts = this.revStartingCostsSaved,
    this.revInitUsers = this.revInitUsersSaved,
    this.revMonthlyUserGrowth = this.revMonthlyUserGrowthSaved,
    this.revMonthlyUserLoss = this.revMonthlyUserLossSaved,
    this.revPerUser = this.revPerUserSaved,
    this.revCOGS = this.revCOGSSaved,
    this.revFixedCostPerMonth = this.revFixedCostPerMonthSaved,
  })*/
  .then((id)=>{
   this.calcRevenueID = id;
   console.log("calcRevenueID", id);
   this.getcalcRevenueID(id);
  }).catch((e)=>{
    console.log("error", e);
  }); // Submit data using CRUD API//take out value? 
  
 }

 getcalcRevenueID (id1: string){
  this.readSustainibleCalcRevenue(id1);
   console.log(id1 + "id")
 }

 readSustainibleCalcRevenue(id:string) {
  //define all variables of a single assessment
this.calcdata = this.fireCalcRevenue.sustainibleCalcRevenueRef.doc(id);
this.calcdata.get().toPromise().then((payload: any) => {
this.dataCalcRev = payload?.data(); 
console.log("calcdata revInitialCapital" + this.dataCalcRev?.revInitialCapital)
});
}

calcRevenueForm() { 
    debugger
  this.calcRevenueFormGroup  = this._formBuilder.group({
      revInitialCapital:  null,
      revStartingCosts: null,
      revPerUser: null,
      revCOGS: null,
      revFixedCostPerMonth: null,
      revInitUsers: null,
      revMonthlyUserGrowth: null,
      revMonthlyUserLoss: null,
      offerListArray: this._formBuilder.array([]),
  })
};
/*
  getAssessmentId() {
    const id = this.actRoute.snapshot.paramMap.get('id');
    this.getAssessmentData(id);
  }

  getAssessmentData(id: string) {
    //define all variables of a single assessment
    this.http.get(`${assessmentApiEndpoint}?key=${id}`)
    .pipe(first())
    .subscribe((payload: any) => {
      this.assessmentPayload = payload['value']; console.info(this.assessmentPayload);
      this.fireAssessment.ref = this.fireAssessment.database.ref(`users/${payload?.uid}/${payload?.key}`);
      this.fireAssessment.ref.once("value").then((snapshot) => {
        this.data = snapshot.val();
      });
    });
  }*/



  /* getAssessmentId(){
     const id = this.actRoute.snapshot.paramMap.get('id');// Getting current component's id or information using ActivatedRoute service
     this.fireAssessment.ReadAssessment(id).valueChanges().subscribe(data=>{
       this.data = data;
       var b = data.child("offerBuyerPower");
       console.log ("teamundv"+b);
       console.log(this.data);
       console.log("testing" + data.offerBuyerPower.value)
       this.accessAssessmentData();
 
      });
   }*/

  

  goBack() {
    this.location.back();
  }

  exportOnClick() {
    const options = {
      filename: 'Sustainible_Recommendations.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
      margin: 12,
      pagebreak: { mode: 'avoid-all' }
    };

    const content: Element = document.getElementById('element-to-export');

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  public show: boolean = true;
  public hide: boolean = false;

  toggle() {
    this.show = !this.show;
    this.hide = !this.hide;
  }


  
  // Revenue Graph
  title = 'chart';

  revInitialCapitalSaved = 0;
  revStartingCostsSaved = 0;
  neededCap = this.revStartingCostsSaved - this.revInitialCapitalSaved;
  revInitUsersSaved = 0;
  monthlyUsersSaved = 0;
  revMonthlyUserGrowthSaved = 0;
  revMonthlyUserLossSaved = 0;
  revPerUserSaved = 0;
  revCOGSSaved = 0;
  revFixedCostPerMonthSaved = 0;

  months = this.calculateMonths();
  monthsEven = [];
  profitableAfter24M: boolean;
  todaysDate = new Date().toLocaleDateString();

  /*Submitting chart to Firestore */
  saveChart() {
    this.revInitialCapitalSaved = this.revInitialCapital;
    this.revStartingCostsSaved = this.revStartingCosts;
    this.revInitUsersSaved = this.revInitUsers;
    this.revMonthlyUserGrowthSaved = this.revMonthlyUserGrowth;
    this.revMonthlyUserLossSaved = this.revMonthlyUserLoss;
    this.revPerUserSaved = this.revPerUser;
    this.revCOGSSaved = this.revCOGS;
    this.revFixedCostPerMonthSaved = this.revFixedCostPerMonth;
  }

  resetChart() {
    this.revInitialCapital = this.revInitialCapitalSaved;
    this.revStartingCosts = this.revStartingCostsSaved;
    this.revInitUsers = this.revInitUsersSaved;
    this.revMonthlyUserGrowth = this.revMonthlyUserGrowthSaved;
    this.revMonthlyUserLoss = this.revMonthlyUserLossSaved;
    this.revPerUser = this.revPerUserSaved;
    this.revCOGS = this.revCOGSSaved;
    this.revFixedCostPerMonth = this.revFixedCostPerMonthSaved;

    this.calculateData();
    this.chart.update();
  }

/*   updateChart() {
    this.data.revInitialCapital = this.revInitialCapital;
    this.data.revStartingCosts = this.revStartingCosts;
    this.data.revInitUsers = this.revInitUsers;
    this.data.revMonthlyUserGrowth = this.revMonthlyUserGrowth;
    this.data.revMonthlyUserLoss = this.revMonthlyUserLoss;
    this.data.revPerUser = this.revPerUser;
    this.data.revCOGS = this.revCOGS;
    this.data.revFixedCostPerMonth = this.revFixedCostPerMonth;

    this.fireAssessment.UpdateAssessments(this.data.revInitialCapital);
    this.fireAssessment.UpdateAssessments(this.data.revStartingCosts);
    this.fireAssessment.UpdateAssessments(this.data.revInitUsers);
    this.fireAssessment.UpdateAssessments(this.data.revMonthlyUserGrowth);
    this.fireAssessment.UpdateAssessments(this.data.revMonthlyUserLoss);
    this.fireAssessment.UpdateAssessments(this.data.revPerUser);
    this.fireAssessment.UpdateAssessments(this.data.revCOGS);
    this.fireAssessment.UpdateAssessments(this.data.revFixedCostPerMonth);
  }

  restoreChart() {
    this.revInitialCapital = this.data.revInitialCapital;
    this.revStartingCosts = this.data.revStartingCosts;
    this.revInitUsers = this.data.revInitUsers;
    this.revMonthlyUserGrowth = this.data.revMonthlyUserGrowth;
    this.revMonthlyUserLoss = this.data.revMonthlyUserLoss;
    this.revPerUser = this.data.revPerUser;
    this.revCOGS = this.data.revCOGS;
    this.revFixedCostPerMonth = this.data.revFixedCostPerMonth;

    this.calculateData();
    this.chart.update();
  } */

  clearChart() {
    this.revInitialCapital = 0;
    this.revStartingCosts = 0;
    this.revInitUsers = 0;
    this.revMonthlyUserGrowth = 0;
    this.revMonthlyUserLoss = 0;
    this.revPerUser = 0;
    this.revCOGS = 0;
    this.revFixedCostPerMonth = 0;

    this.calculateData();
    this.chart.update();
  }

  chartUpdate() {
    this.calculateData();
    this.chart.update();
  }


  /* Dre Chart Configuration  Reference ng2 Charts*/
  chartType = 'line';
  chartData: ChartDataSets[] = [
    {
      data: [],
      label: 'Customers',
      fill: false,
      yAxisID: 'right-y-axis'
    },
    {
      data: [],
      label: 'Revenue',
      fill: false,
      yAxisID: 'left-y-axis'
    },
    {
      data: [],
      label: 'Cost of Goods Sold',
      fill: false,
      yAxisID: 'left-y-axis'
    },
    {
      data: [],
      label: 'Profit',
      fill: false,
      yAxisID: 'left-y-axis'
    },
    {
      data: [],
      label: 'Bottom Line',
      fill: false,
      yAxisID: 'left-y-axis'
    }, /*
    {
      data: [],
      label: 'Industry Standard Revenue',
      fill: false,
      yAxisID: 'left-y-axis',
      hidden: true,
    },
    {
      data: [],
      label: 'Industry Standard Profit',
      fill: false,
      yAxisID: 'left-y-axis',
      hidden: true,
    }, */
  ];

  chartOptions = {
    responsive: true,
    legend: {
      display: true,
      labels: {
        filter: function (legendItem, chartData) {
          if (legendItem.datasetIndex < 5) {
            return (chartData.datasets[legendItem.datasetIndex].label);
          }
        }
      }
    },
    scales: {
      xAxes: [{
      }],
      yAxes: [{
        id: 'left-y-axis',
        type: 'linear',
        position: 'left',
        gridLines: 'white',
        scaleLabel: {
          display: true,
          labelString: 'Profit',
          fontStyle: 'bold'
        },
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value) {
            if ((value >= 1000 && value < 1000000) || (value <= -1000 && value > -1000000)) {
              if (value < 10000) {
                return '$' + (value / 1000).toFixed(1) + 'K';
              } else {
                return '$' + (value / 1000).toFixed() + 'K';
              }
            } else if (value >= 1000000 && value < 1000000000 || (value <= -1000000 && value > -1000000000)) {
              return '$' + (value / 1000000).toFixed(0) + 'M';
            } else if (value >= 1000000000 || (value <= -1000000000 && value > -1000000000000)) {
              return '$' + (value / 1000000000).toFixed(0) + 'B';
            } else {
              return '$' + value;
            }
          }
        }
      }, {
        id: 'right-y-axis',
        type: 'linear',
        position: 'right',
        gridLines: 'white',
        scaleLabel: {
          display: true,
          labelString: 'Customers',
          fontStyle: 'bold'
        },
      }]
    },
  };

  chartColors: Color[] = [
    { // customers
      backgroundColor: '#2e3192',
      borderColor: '#2e3192',
      pointBackgroundColor: '#2e3192',
      pointBorderColor: '#2e3192',
      pointHoverBackgroundColor: '#2e3192',
      pointHoverBorderColor: '#2e3192'
    },
    { // revenue
      backgroundColor: '#25aae1',
      borderColor: '#25aae1',
      pointBackgroundColor: '#25aae1',
      pointBorderColor: '#25aae1',
      pointHoverBackgroundColor: '#25aae1',
      pointHoverBorderColor: '#25aae1'
    },
    { // revCOGS
      backgroundColor: 'red',
      borderColor: 'red',
      pointBackgroundColor: 'red',
      pointBorderColor: 'red',
      pointHoverBackgroundColor: 'red',
      pointHoverBorderColor: 'red'
    },
    { // profit
      backgroundColor: 'green',
      borderColor: 'green',
      pointBackgroundColor: 'green',
      pointBorderColor: 'green',
      pointHoverBackgroundColor: 'green',
      pointHoverBorderColor: 'green'
    },
    { // bottom line
      backgroundColor: 'black',
      borderColor: 'black',
      pointBackgroundColor: 'black',
      pointBorderColor: 'black',
      pointHoverBackgroundColor: 'black',
      pointHoverBorderColor: 'black'
    },/*
    { // is revenue
      backgroundColor: '#9ddcec',
      borderColor: '#9ddcec',
      pointBackgroundColor: '#9ddcec',
      pointBorderColor: '#9ddcec',
      pointHoverBackgroundColor: '#9ddcec',
      pointHoverBorderColor: '#9ddcec'
    },
    { // is profit
      backgroundColor: '#73d766',
      borderColor: '#73d766',
      pointBackgroundColor: '#73d766',
      pointBorderColor: '#73d766',
      pointHoverBackgroundColor: '#73d766',
      pointHoverBorderColor: '#73d766'
    }, */
  ];

  chartLegend = true;

  chartLabels: Label[] = this.months;

  lineChartPlugins = [];

  @ViewChild(BaseChartDirective, { static: false }) chart: BaseChartDirective;
  /* Dre Chart Configuration */
  calculateMonths() {
    let months = [];

    let today = new Date();

    for (let i = 0; i < 24; i++) {
      months.push(today.toLocaleDateString('default', { month: 'short' }) + " " + today.getFullYear().toString());
      today.setMonth(today.getMonth() + 1);
    }

    return months;
  }

  calculateData() {
    this.monthsEven = [];
    // Users M1
    this.chartData[0].data[0] = Number(this.revInitUsers);
    // Revenue M1
    this.chartData[1].data[0] = Number(this.revInitUsers) * Number(this.revPerUser);
    // revCOGS M1
    this.chartData[2].data[0] = Number(this.revInitUsers) * Number(this.revCOGS);
    // Profits M1
    this.chartData[3].data[0] = Number(this.chartData[1].data[0]) - Number(this.chartData[2].data[0]) - Number(this.revFixedCostPerMonth) - Number(this.revStartingCosts);
    // Bottom Line M1
    this.chartData[4].data[0] = Number(this.chartData[3].data[0]) + Number(this.revInitialCapital);

    // this.calcIndustryStandard();
    // this.chartData[5].data = this.industryStandard.getRevenue();
    // this.chartData[6].data = this.industryStandard.getProfit();

    for (let i = 1; i < 24; i++) {
      // Users calculation
      this.chartData[0].data[i] = Math.floor((Number(this.chartData[0].data[i - 1]) * (1 + Number(this.revMonthlyUserGrowth) * .01)) - (Number(this.chartData[0].data[i - 1]) * (Number(this.revMonthlyUserLoss) * 0.01)));

      // Revenue calculation
      this.chartData[1].data[i] = Number(this.chartData[0].data[i]) * Number(this.revPerUser);

      // revCOGS calculation
      this.chartData[2].data[i] = Number(this.chartData[0].data[i]) * Number(this.revCOGS);

      // Profit calcuation
      this.chartData[3].data[i] = Number(this.chartData[1].data[i]) - Number(this.chartData[2].data[i]) - Number(this.revFixedCostPerMonth) + Number(this.chartData[1].data[i - 1]);
      if (Number(this.chartData[3].data[i]) > 0) {
        if (this.monthsEven.length < 1) {
          this.monthsEven.push(this.months[i]);
        }
      }

      // Bottom Line calculation
      this.chartData[4].data[i] = Number(this.chartData[1].data[i - 1]) + Number(this.chartData[3].data[i]);
    }

    if (this.monthsEven.length == 0) {
      this.monthsEven.push("None");
    }

    if (this.chartData[3].data[23] > 0) {
      this.profitableAfter24M = true;
    } else {
      this.profitableAfter24M = false;
    }
  }


  

  formatLabelPercent(value: number) {
    return value + '%';
  }

  formatLabelMoney(value: number) {
    if ((value >= 1000 && value < 1000000)) {
      if (value < 10000) {
        return '$' + (value / 1000).toFixed(1) + 'K';
      } else {
        return '$' + (value / 1000).toFixed() + 'K';
      }
    } else if (value >= 1000000 && value < 1000000000) {
      return '$' + (value / 1000000).toFixed(0) + 'M';
    } else if (value >= 1000000000) {
      return '$' + (value / 1000000000).toFixed(0) + 'B';
    } else {
      return '$' + value;
    }
  }

 

  targetIndustry = class {
    name: string;
    fixedCosts: Number;
    revStartingCosts: Number;
    revenue: Number[];
    profit: Number[];

    constructor(name: string, fixedCosts: Number, revStartingCosts: Number, revenue: Number[], profit: Number[]) {
      this.name = name;
      this.fixedCosts = fixedCosts;
      this.revStartingCosts = revStartingCosts;
      this.revenue = revenue;
      this.profit = profit;
    }

    getName() {
      return this.name;
    }
    getFCosts() {
      return this.fixedCosts;
    }
    getSCosts() {
      return this.revStartingCosts;
    }
    getRevenue() {
      return this.revenue;
    }
    getProfit() {
      return this.profit;
    }
  }

  industryStandard: any;
  iFixedCosts: Number;
  irevStartingCosts: Number;
  iName: string;

  /* calcIndustryStandard() {
    if (this.data.offerIndustry.name === "Accommodation and Food Services") {
      this.industryStandard = new this.targetIndustry("Accommodation and Food Services", 100, 100,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Administration & Business Support Services") {
      this.industryStandard = new this.targetIndustry("Administration & Business Support Services", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Agriculture, Forestry, Fishing & Hunting") {
      this.industryStandard = new this.targetIndustry("Agriculture, Forestry, Fishing & Hunting", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Arts, Entertainment & Recreation") {
      this.industryStandard = new this.targetIndustry("Arts, Entertainment & Recreation", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Construction") {
      this.industryStandard = new this.targetIndustry("Construction", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Educational Services") {
      this.industryStandard = new this.targetIndustry("Educational Services", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Finance & Insurance") {
      this.industryStandard = new this.targetIndustry("Finance & Insurance", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Healthcare & Social Assistance") {
      this.industryStandard = new this.targetIndustry("Healthcare & Social Assistance", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Information") {
      this.industryStandard = new this.targetIndustry("Information", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Manufacturing") {
      this.industryStandard = new this.targetIndustry("Manufacturing", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Professional, Scientific & Technical Services") {
      this.industryStandard = new this.targetIndustry("Professional, Scientific & Technical Servicess", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Real Estate, Rental & Leasing") {
      this.industryStandard = new this.targetIndustry("Real Estate, Rental & Leasing", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Retail Trade") {
      this.industryStandard = new this.targetIndustry("Retail Trade", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Transportation & Warehousing") {
      this.industryStandard = new this.targetIndustry("Transportation & Warehousing", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Utilities") {
      this.industryStandard = new this.targetIndustry("Utilities", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    } else if (this.data.offerIndustry.name === "Wholesale Trade") {
      this.industryStandard = new this.targetIndustry("Wholesale Trade", 0, 0,
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
        [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230]);
    }
    this.iFixedCosts = this.industryStandard.getFCosts();
    this.irevStartingCosts = this.industryStandard.getSCosts();
    this.iName = this.industryStandard.getName();
  }

  showIRevenue() {
    this.chartData[5].hidden = !this.chartData[5].hidden;
    this.chart.update();
  }

  showIProfit() {
    this.chartData[6].hidden = !this.chartData[6].hidden;
    this.chart.update();
  } */

  //Add Team Members
  offerList() : FormArray {
    return this.calcRevenueFormGroup.get("offerListArray") as FormArray
  }

  newOfferList(): FormGroup {
    return this._formBuilder.group({
     offerType: '',
     offerName: '',
     offerDescription: ' ',
     offerPrice: '',
    })
  }
  
  addOfferList() {
    this.offerList().push(this.newOfferList());
  }

  removeOfferList(i:number) {
    this.offerList().removeAt(i);
  }

  update(){
    console.log("Update function", this.calcRevID);
    this.fireCalcRevenue.updateSustainibleCalcRevenue(this.calcRevID, this.calcRevenueFormGroup.value);
    this.readSustainibleCalcRevenue(this.calcRevID);
  }
   
}
